import Popup from '../Popup/Popup';
import Buttons from '../Buttons/Buttons'
import { useGlobalState } from "../../Contexts/GlobalStateContext";

const NetworkErrorModal = () => {
  const { isNetworkErrorVisible, setNetworkErrorVisible, setVoyceToken } = useGlobalState();
  if (!isNetworkErrorVisible) return null;
  const handleClose = () => {
    setNetworkErrorVisible(false);
    setVoyceToken(null);
    window.location.reload();
  }

  return (
    <Popup
      show={isNetworkErrorVisible}
      handleClose={handleClose}
      titleStyle="dashboard-popup-title"
      body={
        <>
          <div>You have been disconnected from the Network.</div>
          <div></div>
          <div>Please login again.</div>
        </>
        }
      bodyStyle="dashboard-popup-body"
      footer={
        <>
          <div className="paymentpage-success-btn">
            <Buttons handleSubmit={handleClose} text={"Login"} CardElement='payment-element' /></div>
        </>
      }
      footerStyle="dashboard-popup-footer"
    />
  )
}

export default NetworkErrorModal;